import React from 'react';
import classNames from 'classnames';

import type { EventType } from '../services/EventType';
import Tracking from '../services/Tracking';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'secondary' | 'mono' | 'link';
  primary?: boolean;
  block?: boolean;
  outline?: boolean;
  sm?: boolean;
  lg?: boolean;
  icon?: React.ReactNode | string | boolean;
  iconRight?: boolean;
  track?: EventType | [EventType, ...UnsafeAny];
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | boolean | Promise<void>;
}

export default function Button({
  variant,
  block,
  primary,
  outline,
  sm,
  lg,
  icon,
  iconRight,
  track,
  ...props
}: ButtonProps) {
  if (primary) {
    variant = 'primary';
  }
  const cn = classNames('button', variant && `button-${variant}`, props.className, {
    'button-block': block,
    'button-outline': outline,
    'button-icon': !!icon,
    'button-sm': sm,
    'button-lg': lg,
  });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (track) {
      const eventType = typeof track === 'string' ? track : track[0];
      const args = typeof track === 'string' ? [] : track.slice(1);
      Tracking.track(eventType, ...args);
    }
    if (props.onClick) {
      return props.onClick(e);
    }
  };

  return (
    <button {...props} className={cn} onClick={handleClick} type={props.type ?? 'button'}>
      {icon && typeof icon !== 'boolean' ? (
        <>
          {typeof icon === 'string' ? (
            <i
              className={classNames(`icon icon-${icon}`, {
                'icon-right': iconRight,
              })}
            />
          ) : (
            icon
          )}
          {typeof props.children === 'string' ? <span>{props.children}</span> : props.children}
        </>
      ) : (
        props.children
      )}
    </button>
  );
}
